interface VerticalSeparatorProps {
  className?: string;
}

const VerticalSeparator = ({ className = '' }: VerticalSeparatorProps) => {
  return (
    <div
      className={`h-6 w-px bg-neutralText opacity-20 dark:bg-neutralText-dark ${className}`}
    />
  );
};

export default VerticalSeparator;
